<script setup lang="ts">
import { computed } from 'vue'

const modelValue = defineModel<string>({ default: '' })

const props = withDefaults(
  defineProps<{
    placeholder?: string
    name?: string
    id?: string
  }>(),
  {
    placeholder: 'Search…',
  },
)

const showClear = computed(() => Boolean(modelValue.value))
const clear = () => (modelValue.value = '')
</script>

<template>
  <div class="relative inline-block">
    <input
      v-model="modelValue"
      type="text"
      :placeholder="props.placeholder"
      :name="props.name"
      :id="props.id"
      class="relative block whitespace-nowrap rounded-md border-none bg-white px-2 py-1 pr-7 text-sm font-medium text-gray-700 shadow-sm ring-1 ring-gray-700/20 hover:shadow-md hover:ring-gray-700/30 hover:transition-shadow focus:outline-none active:shadow-sm active:transition-none sm:px-2.5 sm:py-1.5 sm:text-sm"
      v-bind="$attrs"
    />
    <button
      v-if="showClear"
      type="button"
      class="absolute inset-y-0 right-1 my-auto flex h-6 w-6 items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600 focus:outline-none"
      aria-label="Clear search"
      @click="clear"
    >
      ✕
    </button>
  </div>
</template>
